'use strict';

import angular from 'angular';


export default class SignupController {
  errors = {};
  submitted = false;

  /*@ngInject*/
  constructor(Auth, $state) {
    this.Auth = Auth;
    this.$state = $state;

    this.user = {
      email: '',
      password: '',
      address: {}
    };
  }
  register(form) {
    this.submitted = true;

    if(form.$valid) {
      return this.Auth.createUser(this.user)
        .then(() => {
          // Account created, redirect to home
          this.$state.go('home');
        })
        .catch(err => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          if (err.name) {
            angular.forEach(err.errors, (error, field) => {
              form[field].$setValidity('mongoose', false);
              this.errors[field] = error.message;
            });
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js